import ResendSharingLoggedOutPage from "./ResendSharingLoggedOutPage";

export default ResendSharingLoggedOutPage;
